import { CLienteAPi } from "../../client_api";

export class Request_userTypes_list {
    ConexionIacpos: number;
    clienteAPI: CLienteAPi;
    Nombre: string;
    pkId:string;
    Descripcion: string;
}
